/* @ngInject */
const myTextArea = (
  labels,
  utils,
  types,
  optionsHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myNature: '=',
      myName: '=',
      ngModel: '=',
      myOptions: '=',
      enableValidator: '=?',
    },

    template: require('./myTextArea.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {

    },

    link: {
      pre: (scope, element, attrs) => {
        const defaultOptions = {
          icon: 'error',
          label: 'error',
          ref: 'error',
          required: false,
          disabled: false,
          type: types.text(),
          displayNullRadio: false,
          unique: false,
          messages: {
            exists: labels.error.input.exists,
          },
        }

        const options = optionsHandler.setDefaults(scope.myOptions, defaultOptions)

        scope.icon = options.icon
        scope.label = options.label
        scope.id = options.ref + utils.math.random()
        scope.required = false
        scope.disabled = options.disabled
        scope.type = options.type
        scope.displayNullRadio = options.displayNullRadio
        scope.messages = options.messages

        if (scope.enableValidator) {
          scope.required = options.required
        }
      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myTextArea



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myTextArea.js